import { render, staticRenderFns } from "./MyData.vue?vue&type=template&id=4ae106eb&scoped=true&"
import script from "./MyData.vue?vue&type=script&lang=js&"
export * from "./MyData.vue?vue&type=script&lang=js&"
import style0 from "./MyData.vue?vue&type=style&index=0&id=4ae106eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae106eb",
  null
  
)

export default component.exports